import React from "react";
import PropTypes from "prop-types";

import GLogo from "./GLogo";
import "./SoleraLoader.css";

class UILoader extends React.Component {
  componentDidMount() {
    this.props.onMount();
  }

  render() {
    return (
      <div className="solera-loader">
        <div className="logo">
          <GLogo />
        </div>
      </div>
    );
  }
}

UILoader.propTypes = {
  onMount: PropTypes.func
};

UILoader.defaultProps = {
  onMount: () => {}
};

export default UILoader;
